import React from 'react';
import { useTranslation } from 'react-i18next';
import U2000ActionBtn from '../../../../u2000Core/components/buttons/U2000ActionBtn';
import U2000ResponsiveToolbar from '../../../../u2000Core/components/toolbar/U2000ResponsiveToolbar';
import { FaPlus, FaRegFile, FaTrashAlt } from 'react-icons/fa';
import { useU2000AuthContext } from '../../../../u2000Core/context/auth/U2000UseAuthContext';
import type { U2000FormStateHandlersReturn } from '../../../../u2000Core/reducer/formReducer/U2000FormStateHandlers';
import { U2000FormStateEnumState } from '../../../../u2000Core/reducer/formReducer/U2000FormState';
import { NS, U3150ROLES } from '../../../U3150';
import type { U3150TaskFormRow } from '../../../U3150Service';

export type U3150TaskFormToolbarHandlers = U2000FormStateHandlersReturn<U3150TaskFormRow> & {
  addNewTask: () => void;
  modifyTask: () => void;
  deleteTask: () => void | Promise<void>;
};

interface U3150TaskFormToolBarProps {
  formStateHandlers: U3150TaskFormToolbarHandlers;
}

export const U3150TaskFormToolBar: React.FC<U3150TaskFormToolBarProps> = ({ formStateHandlers }) => {
  const formState = formStateHandlers.getFormState();
  const { hasRole } = useU2000AuthContext();
  const { t } = useTranslation();

  const actions = [
    {
      key: 'add',
      label: t('btnAdd', { ns: NS }),
      hasRole: hasRole(U3150ROLES.ADD),
      handleClick: () => {
        formStateHandlers.addNewTask();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaPlus,
      Component: U2000ActionBtn,
    },
    {
      key: 'modify',
      label: t('btnModify', { ns: NS }),
      hasRole: hasRole(U3150ROLES.EDIT),
      handleClick: () => {
        formStateHandlers.modifyTask();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: 'delete',
      label: t('btnDelete', { ns: NS }),
      hasRole: hasRole(U3150ROLES.DELETE),
      handleClick: () => {
        formStateHandlers.deleteTask();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
